import { parse } from 'cookie';

import type { AppliedJobStatus } from 'src/types/graphql';

export const navigateToUrl = (destination?: string | null) => {
  if (window && destination) {
    window.location.assign(destination);
  }
};

type onClick = (e: React.MouseEvent) => void;

export const withScroll = (onClick: onClick) => (e: React.MouseEvent) => {
  window.scrollTo(0, 0);
  onClick(e);
};

export const getJobStatus = (isActive: boolean) =>
  isActive ? 'Active' : 'Expired';

export const getEvent = (events: any, status: any) => {
  if (events) {
    const viewedEvent = events.find((event: any) => event?.status === status);
    if (viewedEvent) {
      return viewedEvent;
    }
  }

  return null;
};

export const getSessionId = () =>
  parse(window.document.cookie).JobseekerSessionId;

export const isSeekTest = (): boolean => {
  const { document = { cookie: '' }, SEEK_TEST = false } =
    typeof window !== 'undefined' ? window : {};
  const cookie = document.cookie || '';
  const parsedCookie = Boolean(cookie) ? parse(cookie) : { SEEK_TEST: false };

  return Boolean(SEEK_TEST) || parsedCookie.SEEK_TEST === 'true';
};

export const getEventLabel = (
  status: AppliedJobStatus,
  t: (key: string, params?: Record<string, string>) => string,
  brand: string,
) => {
  if (status === 'Applied') {
    return t('Applied on', { brand });
  }
  if (status === 'Viewed') {
    return t('Viewed by employer');
  }
  if (status === 'NotSuitable') {
    return t('Unlikely to progress');
  }
  return '';
};

export const getEventDesc = (
  status: AppliedJobStatus,
  t: (key: string, params?: Record<string, string>) => string,
) => {
  if (status === 'NotSuitable') {
    return t('It appears that');
  }
  return t('Each employer has');
};
